<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>

    <template #hero>
      <PageHero page="profil" title="Profil Jurusan Manajemen" current="Profil"
        subtitle="Fakultas Ekonomi dan Bisnis — Universitas Negeri Gorontalo" />
    </template>
    <template v-slot:default>
      <!-- ===== CONTENT ===== -->
      <main class="bg-gray-50">
        <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 py-12 space-y-10">

          <!-- Visi -->
          <article v-if="p.visi"
            class="relative p-6 overflow-hidden bg-white border border-gray-100 shadow-sm sm:p-8 rounded-2xl">
            <div class="absolute top-0 left-0 w-1.5 h-full bg-maroon-600"></div>
            <div class="flex items-center gap-3 mb-5">
              <span class="flex items-center justify-center text-white w-11 h-11 rounded-xl bg-maroon-600">
                <i class="fa-solid fa-bullseye"></i>
              </span>
              <h2 class="text-xl font-bold text-gray-900 sm:text-2xl">Visi</h2>
            </div>
            <div class="leading-relaxed prose text-gray-700 prose-gray max-w-none" v-html="p.visi"></div>
          </article>

          <!-- Akreditasi -->
          <article v-if="p.akreditasi"
            class="relative p-6 overflow-hidden text-white shadow-md sm:p-8 rounded-2xl bg-gradient-to-br from-maroon-700 to-maroon-950">
            <i class="absolute text-white fa-solid fa-award -right-4 -bottom-4 text-9xl opacity-10"></i>
            <div class="relative flex items-center gap-3 mb-5">
              <span class="flex items-center justify-center w-11 h-11 rounded-xl bg-white/15 backdrop-blur">
                <i class="fa-solid fa-award"></i>
              </span>
              <h2 class="text-xl font-bold sm:text-2xl">Akreditasi</h2>
            </div>
            <div class="relative leading-relaxed prose prose-invert max-w-none" v-html="p.akreditasi"></div>
          </article>

          <!-- Profil Pejabat -->
          <section class="pt-2">
            <ProfilPejabat :pejabatList="formasi" inline :hideHeaderInline="false" title="Profil Pejabat" />
          </section>

          <!-- Profil Pegawai -->
          <section>
            <ProfilPegawai :pegawaiList="pegawai" inline :hideHeaderInline="false" title="Profil Pegawai" />
          </section>
        </div>
      </main>
    </template>

    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { computed } from "vue";
import { Link } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import PageHero from "@/Components/Web/PageHero.vue";
import ProfilPejabat from "@/Components/Web/ProfilPejabat.vue";
import ProfilPegawai from "@/Components/Web/ProfilPegawai.vue";

const props = defineProps({
  profil: { type: Object, required: true },
  formasi: { type: Object, required: true },
  pegawai: { type: Object, required: true },
});

// Ambil record profil pertama dengan aman (mendukung { data: [...] } maupun array).
const p = computed(() => {
  const d = props.profil?.data ?? props.profil;
  return Array.isArray(d) ? d[0] || {} : d || {};
});
</script>

<style scoped>
/* Daftar bernomor pada konten kaya (visi/misi) */
:deep(ol) {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin: 1rem 0;
}

:deep(ul) {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 1rem 0;
}

:deep(li) {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

:deep(p) {
  margin: 0.5rem 0;
}
</style>
